import React, { useState } from 'react';
import { services } from '../mock/data';
import { Check, Play, X } from 'lucide-react';
import ContactButtons from '../components/ContactButtons';

const Services = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Hero Section */}
      <section className="py-16 bg-[var(--dark-card)]">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold font-['Playfair_Display'] gold-gradient-text mb-6">
            Hizmetlerimiz
          </h1>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed">
            Geleneksel Türk hamamından modern masaj tekniklerine kadar geniş bir yelpazede
            profesyonel sağlık ve güzellik hizmetleri sunuyoruz.
          </p>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-16 bg-[var(--dark-bg)]">
        <div className="container mx-auto px-4">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div
                key={service.id}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center fade-in`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Content */}
                <div className={`space-y-6 ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <h2 className="text-3xl md:text-4xl font-bold font-['Playfair_Display'] text-[var(--gold)]">
                    {service.title}
                  </h2>
                  <p className="text-gray-300 leading-relaxed text-lg">{service.description}</p>

                  {/* Benefits */}
                  <div className="space-y-3">
                    <h3 className="text-xl font-semibold text-[var(--gold-light)]">
                      Faydaları:
                    </h3>
                    <ul className="space-y-2">
                      {service.benefits.map((benefit, i) => (
                        <li key={i} className="flex items-start space-x-3">
                          <Check size={20} className="text-[var(--gold)] mt-1 flex-shrink-0" />
                          <span className="text-gray-400 text-sm">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="pt-4">
                    <ContactButtons />
                  </div>
                </div>

                {/* Video Thumbnail */}
                <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <div 
                    className="glass rounded-2xl overflow-hidden aspect-video card-hover cursor-pointer relative group"
                    onClick={() => setSelectedVideo(service.videoUrl)}
                  >
                    <video
                      src={service.videoUrl}
                      className="w-full h-full object-cover"
                      muted
                    />
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/30 transition-all duration-300">
                      <div className="w-20 h-20 rounded-full bg-[var(--gold)] flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <Play size={32} className="text-black ml-1" fill="currentColor" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Massage Types Info */}
      <section className="py-16 bg-[var(--dark-card)]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h2 className="text-3xl md:text-4xl font-bold font-['Playfair_Display'] text-[var(--gold)]">
              Masaj Çeşitlerimiz
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="glass rounded-xl p-6 text-left space-y-3">
                <h3 className="text-xl font-bold text-[var(--gold-light)]">İsveç Masajı</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Klasik ve en popüler masaj tekniklerinden biri. Orta şiddetli basınç ile uygulanan
                  uzun vurunlarla kaslarınız gevşer, kan dolaşımınız düzenlenir.
                </p>
              </div>
              <div className="glass rounded-xl p-6 text-left space-y-3">
                <h3 className="text-xl font-bold text-[var(--gold-light)]">Derin Doku Masajı</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Kronik kas ağrıları ve tutulmalar için ideal. Derin baskı ve yavaş hareketlerle
                  kas dokusunun iç katmanlarına ulaşılır.
                </p>
              </div>
              <div className="glass rounded-xl p-6 text-left space-y-3">
                <h3 className="text-xl font-bold text-[var(--gold-light)]">Aromaterapi Masajı</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Doğal bitki yağları ve esanslar ile uygulanan masaj. Hem fiziksel hem de zihinsel
                  rahatlama sağlar, stresi azaltır.
                </p>
              </div>
              <div className="glass rounded-xl p-6 text-left space-y-3">
                <h3 className="text-xl font-bold text-[var(--gold-light)]">4 El Masajı</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  İki masözün senkronize çalışmasıyla uygulanan lüks bir deneyim. Eşsiz bir rahatlama
                  ve huzur hissi yaşatır.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-in fade-in"
          onClick={() => setSelectedVideo(null)}
        >
          <button
            onClick={() => setSelectedVideo(null)}
            className="absolute top-4 right-4 text-white hover:text-[var(--gold)] transition-colors duration-300 z-10"
            aria-label="Kapat"
          >
            <X size={40} />
          </button>
          <div className="w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
            <video
              src={selectedVideo}
              controls
              autoPlay
              className="w-full rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;